import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  title: {
    justifyContent: 'center',
      color: theme.palette.text.nonary,
    fontFamily: 'MontserratExtraBold',
    fontWeight: '800',
    fontStyle: 'normal',
    fontSize: '56px',
lineHeight: '74px',
  },
}));

export default useStyles;
